import type { ReactElement, ReactNode } from 'react';
import Box from '@mui/material/Box';
import { FilterButton, FilterForm, TopToolbar } from 'react-admin';

type DataTableListActionsProps = {
  children?: ReactNode;
  filters?: ReactElement[];
};

type DataTableFilterControlsProps = {
  children?: ReactNode;
  filters: ReactElement[];
};

export const DataTableFilterControls = ({ children, filters }: DataTableFilterControlsProps) => (
  <Box
    sx={{
      alignItems: 'flex-end',
      display: 'flex',
      flexGrow: 1,
      flexWrap: 'wrap',
      gap: 1,
      minWidth: 0,
      '& form': { mt: 0 },
    }}
  >
    <FilterForm filters={filters} />
    {children ?? <FilterButton filters={filters} />}
  </Box>
);

export const DataTableListActions = ({ children, filters = [] }: DataTableListActionsProps) => (
  <TopToolbar
    sx={{
      alignItems: 'flex-end',
      flexWrap: 'wrap',
      gap: 1,
      justifyContent: filters.length ? 'space-between' : 'flex-end',
      width: '100%',
    }}
  >
    {filters.length ? (
      <DataTableFilterControls filters={filters} />
    ) : null}
    {children ? (
      <Box sx={{ display: 'flex', flexShrink: 0, gap: 1, ml: 'auto' }}>
        {children}
      </Box>
    ) : null}
  </TopToolbar>
);
